import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6532e717"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-3 pl-5 pr-5" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", { class: "font-bold" }, "Course Details")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "card mt-5 rounded responsiveCard flex items-center justify-center w-full h-16"
}
const _hoisted_5 = { class: "cursor-pointer empty rowHeight" }
const _hoisted_6 = { class: "relative h-5" }
const _hoisted_7 = { class: "flex items-center justify-center w-full h-16" }
const _hoisted_8 = {
  key: 1,
  class: "card mt-5 rounded responsiveCard"
}
const _hoisted_9 = { class: "" }
const _hoisted_10 = {
  key: 0,
  class: "h-full responsiveHeight"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "text-white text-lg" }
const _hoisted_13 = { class: "card-body courseInfo" }
const _hoisted_14 = { class: "details courseHeight flex flex-col h-full" }
const _hoisted_15 = { class: "flex flex-row" }
const _hoisted_16 = { class: "font-opensans" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 0,
  class: "positionResponsive mt-2"
}
const _hoisted_19 = { class: "flex items-center mt-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-semibold w-16" }, "Start Date:", -1))
const _hoisted_21 = { class: "startdate font-semibold flex justify-center items-center rounded font-opensans text-xs h-5 border border-primary bg-primaryBg text-primary px-2" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "flex items-center mt-2" }
const _hoisted_25 = {
  key: 0,
  class: "text-xs font-semibold w-16"
}
const _hoisted_26 = {
  key: 1,
  class: "text-xs font-semibold w-20"
}
const _hoisted_27 = {
  key: 0,
  class: "duedate font-semibold flex justify-center items-center rounded font-opensans text-xs h-5 px-2 border border-error bg-highColor text-error"
}
const _hoisted_28 = {
  key: 1,
  class: "duedate font-semibold flex justify-center items-center rounded font-opensans text-xs h-5 px-2 border completedlablestyle"
}
const _hoisted_29 = { class: "courseStatus" }
const _hoisted_30 = {
  key: 0,
  class: "h-full w-full p-2"
}
const _hoisted_31 = { class: "flex items-center justify-center chart relative" }
const _hoisted_32 = { class: "flex items-center justify-center flex-col" }
const _hoisted_33 = {
  key: 0,
  class: "btndisabled mt-3"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "Certificate", -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 0,
  class: "courseStatus"
}
const _hoisted_37 = { class: "h-full w-full p-2" }
const _hoisted_38 = { class: "flex items-center justify-center chart relative" }
const _hoisted_39 = { class: "flex items-center justify-center flex-col" }
const _hoisted_40 = {
  key: 0,
  class: "btndisabled mt-3"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "Certificate", -1))
const _hoisted_42 = [
  _hoisted_41
]
const _hoisted_43 = { class: "tableCornerRadius rounded" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "header cursor-pointer flex items-center" }, " Modules ")
  ])
], -1))
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "cursor-pointer empty rowHeight" }
const _hoisted_47 = { class: "relative h-5" }
const _hoisted_48 = { class: "flex items-center justify-center w-full h-16" }
const _hoisted_49 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumb = _resolveComponent("breadCrumb")!
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_breadCrumb, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
    ]),
    _hoisted_3,
    _createElementVNode("div", null, [
      (_ctx.dataLoading == true && _ctx.completedCourse == false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_dots_loader)
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_ctx.courseDetails.courseImageUrl)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("img", {
                      src: _ctx.courseDetails.courseImageUrl,
                      class: "card-bordered rounded-l-sm bg-cover bg-no-repeat bg-center h-full imageResponsive"
                    }, null, 8, _hoisted_11)
                  ]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(["h-full", {'bg-primary rounded-l-sm flex justify-center items-center responsiveHeight1':!_ctx.courseDetails.courseImageUrl}])
                  }, [
                    _createElementVNode("h1", _hoisted_12, _toDisplayString(_ctx.courseDetails.courseName), 1)
                  ], 2))
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("h1", _hoisted_16, _toDisplayString(_ctx.courseDetails.courseName), 1)
                ]),
                _createElementVNode("div", {
                  class: "textDivResponsive table-ellipsis text-grey mt-2 cursor-pointer flex-1",
                  onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.doFalse()))
                }, [
                  _createElementVNode("p", {
                    class: "description font-opensans non-italic font-normal text-base text-black",
                    onMousemove: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toolTip( $event, _ctx.courseDetails.courseDescription, 'text')))
                  }, _toDisplayString(_ctx.courseDetails.courseDescription), 33),
                  (_ctx.toolTipActive)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                      ]))
                    : _createCommentVNode("", true)
                ], 32),
                (_ctx.series[0] != 100 || _ctx.series[0] == 100)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _createElementVNode("div", _hoisted_21, [
                          (_ctx.startedAt)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.startedAt), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_23, "Not Started"))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        (_ctx.series[0] != 100)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Due Date:"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_26, "Completed:")),
                        _createElementVNode("div", null, [
                          (_ctx.series[0]!=100)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.userActivity.checkdueDate), 1))
                            : (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.formatTime(_ctx.userActivity.completedAt)), 1))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_29, [
                (_ctx.responsiveVariable == true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createVNode(_component_apexchart, {
                          width: "200",
                          height: "200",
                          type: "radialBar",
                          options: _ctx.chartOptions,
                          series: _ctx.series
                        }, null, 8, ["options", "series"])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        (_ctx.series[0] == 0 && _ctx.startedAt == '')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "btnprimary",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.startCourse()))
                            }, "Start"))
                          : (_ctx.series[0] == 100)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "btnprimary",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.startCourse()))
                              }, "Retake"))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: "btnprimary cursor-pointer",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.startCourse()))
                              }, "Resume")),
                        _createElementVNode("div", null, [
                          (_ctx.series[0] != 100)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, "Certificate"))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "btnprimary mt-3",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.downloadCerificate(_ctx.userInfo)))
                              }, _hoisted_35))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.responsiveVariable == false)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_component_apexchart, {
                        width: "200",
                        height: "200",
                        type: "radialBar",
                        options: _ctx.chartOptions,
                        series: _ctx.series
                      }, null, 8, ["options", "series"])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      (_ctx.series[0] == 0 && _ctx.startedAt == '')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "btnprimary",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.startCourse()))
                          }, "Start"))
                        : (_ctx.series[0] == 100)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "btnprimary",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.startCourse()))
                            }, "Retake"))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 2,
                              class: "btnprimary cursor-pointer",
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.startCourse()))
                            }, "Resume")),
                      _createElementVNode("div", null, [
                        (_ctx.series[0] != 100)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, "Certificate"))
                          : (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "btnprimary mt-3",
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.downloadCerificate(_ctx.userInfo)))
                            }, _hoisted_42))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("table", _hoisted_43, [
        _hoisted_44,
        (_ctx.dataLoading == true)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_45, [
              _createElementVNode("tr", _hoisted_46, [
                _createElementVNode("td", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_component_dots_loader)
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("tbody", _hoisted_49, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modules, (module, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, _toDisplayString(module.moduleName), 1)
                ]))
              }), 128))
            ]))
      ])
    ])
  ]))
}